// extracted by mini-css-extract-plugin
module.exports = {"root":"checkbox_list_filter__root__-sP4w margin__margin_bottom_xsmall__5tXbk"};